/**
 * @fileoverview Menu dropdown translations for all supported locales.
 */

import type { SupportedLang } from './lang.js';
import { currentLang } from './lang.js';

interface MenuStrings {
    sound:            string;
    buyThemes:        string;
    restorePurchase:  string;
    faq:              string;
    stories:          string;
    language:         string;
    tapToStart:       string;
    startGame:        string;
    readStories:      string;
    feedbackMessages: string[];
}

const menuTranslations: Record<SupportedLang, MenuStrings> = {
    en: {
        sound:           'Sound',
        buyThemes:       'Buy More Themes - $2.99',
        restorePurchase: 'Restore Purchase',
        faq:             'FAQ',
        stories:         'Night Time Stories',
        language:        'Change Language',
        tapToStart:      'Tap to Start',
        startGame:       'Start Game',
        readStories:     'Read Bedtime Stories',
        feedbackMessages: [
            'Good Job! 🌟',
            'Amazing! ⭐',
            'Well Done! 🎉',
            'Awesome! 🎊',
            'Great! 👏',
            'Perfect! ✨',
        ],
    },
    de: {
        sound:           'Ton',
        buyThemes:       'Mehr Themen kaufen – 2,99 $',
        restorePurchase: 'Kauf wiederherstellen',
        faq:             'FAQ',
        stories:         'Gutenachtgeschichten',
        language:        'Sprache ändern',
        tapToStart:      'Tippen zum Starten',
        startGame:       'Spiel starten',
        readStories:     'Gutenachtgeschichten lesen',
        feedbackMessages: [
            'Super gemacht! 🌟',
            'Toll! ⭐',
            'Sehr gut! 🎉',
            'Wunderbar! 🎊',
            'Prima! 👏',
            'Perfekt! ✨',
        ],
    },
    es: {
        sound:           'Sonido',
        buyThemes:       'Comprar más temas – $2.99',
        restorePurchase: 'Restaurar compra',
        faq:             'Preguntas frecuentes',
        stories:         'Cuentos para dormir',
        language:        'Cambiar idioma',
        tapToStart:      'Toca para empezar',
        startGame:       'Empezar juego',
        readStories:     'Leer cuentos para dormir',
        feedbackMessages: [
            '¡Buen trabajo! 🌟',
            '¡Increíble! ⭐',
            '¡Muy bien! 🎉',
            '¡Genial! 🎊',
            '¡Estupendo! 👏',
            '¡Perfecto! ✨',
        ],
    },
    fr: {
        sound:           'Son',
        buyThemes:       'Acheter plus de thèmes – 2,99 $',
        restorePurchase: 'Restaurer l\'achat',
        faq:             'FAQ',
        stories:         'Histoires du soir',
        language:        'Changer de langue',
        tapToStart:      'Appuyer pour démarrer',
        startGame:       'Commencer le jeu',
        readStories:     'Lire des histoires du soir',
        feedbackMessages: [
            'Bien joué ! 🌟',
            'Incroyable ! ⭐',
            'Bravo ! 🎉',
            'Super ! 🎊',
            'Génial ! 👏',
            'Parfait ! ✨',
        ],
    },
    pt: {
        sound:           'Som',
        buyThemes:       'Comprar mais temas – $2,99',
        restorePurchase: 'Restaurar compra',
        faq:             'Perguntas frequentes',
        stories:         'Histórias para dormir',
        language:        'Mudar idioma',
        tapToStart:      'Toque para começar',
        startGame:       'Iniciar jogo',
        readStories:     'Ler histórias para dormir',
        feedbackMessages: [
            'Bom trabalho! 🌟',
            'Incrível! ⭐',
            'Muito bem! 🎉',
            'Fantástico! 🎊',
            'Ótimo! 👏',
            'Perfeito! ✨',
        ],
    },
    bs: {
        sound:           'Zvuk',
        buyThemes:       'Kupi još tema - $2.99',
        restorePurchase: 'Vrati kupovinu',
        faq:             'Česta pitanja',
        stories:         'Priče za laku noć',
        language:        'Promijeni jezik',
        tapToStart:      'Dodirni za početak',
        startGame:       'Započni igru',
        readStories:     'Čitaj priče za laku noć',
        feedbackMessages: [
            'Dobar posao! 🌟',
            'Nevjerovatno! ⭐',
            'Odlično urađeno! 🎉',
            'Sjajno! 🎊',
            'Odlično! 👏',
            'Savršeno! ✨',
        ],
    },
};

export const menuStrings: MenuStrings = menuTranslations[currentLang];
